<template>
  <div style="width: 100%;" class="custom-container">
    <v-row dense no-gutters>
      <v-col cols="12">
        <Table
          :key="tableKey"
          :items="storages"
          :loading="loading"
          @fetchStorages="fetchStorage($event)"
        ></Table>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Table from './StorageDatatable.vue'
import {
  getStoragesUsingGET as getStorage
} from '@/utils/api'
import { mapActions } from 'vuex'

export default {
  components: {
    Table
  },
  data() {
    return {
      err: '',
      success: '',
      tableKey: 0,
      loading: false,
      storages: { items: [], meta: {} }
    }
  },
  computed: {},
  created() {
    if (this.$route.params && this.$route.params.message) {

      this.addSnackbar({
        message: this.$route.params.message,
        timeout: 5000,
        color: 'success'
      })
    }
  },
  methods: {
    ...mapActions('app', ['addSnackbar']),

    fetchStorage(options) {
      this.loading = true

      const obj = {}

      if (options) {
        if (options.options && options.options.itemsPerPage !== -1) {
          obj.page = options.resetPage ? 1 : options.options.page || 1
          obj.size = options.options.itemsPerPage || 25
        } else {
          obj.page = 1
          obj.size = 25
        }
      } else {
        obj.page = 1
        obj.size = 25
      }

      if (options?.options?.sortDesc && options.options.sortDesc.length > 0) {
        obj.orderDirection = options.options.sortDesc[0] ? 'DESC' : 'ASC'
      } else {
        obj.orderDirection = 'DESC'
      }

      if (options && options.options && options.options.sortBy && options.options.sortBy.length > 0) {
        obj.orderField = options.options.sortBy[0]
      } else {
        obj.orderField = 'createdOn'
      }

      if (options && options.processId) {
        obj.processId = options.processId
      }

      if (options && options.key) {
        obj.key = options.key
      }

      getStorage(obj)
        .then((res) => {
          this.storages = res.data.data
          this.loading = false
        })
        .catch((error) => {
          this.loading = false
          this.addSnackbar({
            message: error,
            timeout: 5000,
            color: 'error'
          })
          console.log(error)
        })
    }
  }
}
</script>
